import { gql } from "graphql-request";

const HANDBOOK_DETAIL_FIELDS = `
  _id
  slug
  title
  subtitle
  thumbnailUrl
  parentIds
  relatedIds
  aboutSlot
  footnotes {
    id
    content
  }
  content
  excerpt
  tags
  status
  publishedAt
  createdBy
  updatedBy
  createdAt
  updatedAt
`;

export const ADMIN_CREATE_HANDBOOK = gql`
  mutation AdminCreateHandbook($input: AdminCreateHandbookInputDto!) {
    adminCreateHandbook(input: $input) {
      success
      message
      handbook {
        ${HANDBOOK_DETAIL_FIELDS}
      }
    }
  }
`;

export const ADMIN_UPDATE_HANDBOOK = gql`
  mutation AdminUpdateHandbook($input: AdminUpdateHandbookInputDto!) {
    adminUpdateHandbook(input: $input) {
      success
      message
      handbook {
        ${HANDBOOK_DETAIL_FIELDS}
      }
    }
  }
`;

export const ADMIN_PUBLISH_HANDBOOK = gql`
  mutation AdminPublishHandbook($handbookId: String!) {
    adminPublishHandbook(handbookId: $handbookId) {
      success
      message
      handbook {
        ${HANDBOOK_DETAIL_FIELDS}
      }
    }
  }
`;

export const ADMIN_UNPUBLISH_HANDBOOK = gql`
  mutation AdminUnpublishHandbook($handbookId: String!) {
    adminUnpublishHandbook(handbookId: $handbookId) {
      success
      message
      handbook {
        ${HANDBOOK_DETAIL_FIELDS}
      }
    }
  }
`;

export const ADMIN_DELETE_HANDBOOK = gql`
  mutation AdminDeleteHandbook($handbookId: String!) {
    adminDeleteHandbook(handbookId: $handbookId) {
      success
      message
    }
  }
`;
